<template>
    <div />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { postWithJson } from 'library/utils/http/axios'
import getUrlSearch from 'library/functions/getUrlSearch'
import changeBtoken from '@/functions/changeBtoken'

const postLiveEnter = (params = {}) => postWithJson('/api/app/live/enter.json', params)
export default defineComponent({
    async setup() {
        let {
            liveId,
            ticket,
            token,
            isPlayback,
            forceInto,
            isMini,
            share_from,
            share_user,
            share_date
        } = getUrlSearch()
        // token不能直接去取btoken，存在不同商户的情况，token需要通过allTokens获取，allTokens有缓存时间，用deadTime
        if (!token) {
            token = await changeBtoken(ticket)
        }
        let params = {ticket, liveId, token, isPlayback, forceInto, share_from, share_user, share_date}
        postLiveEnter(params).then(({data}) => {
            if (data && data.url) {
                if (+isMini === 1) {
                    window.location.href = data.appletUrl
                }
                else {
                    window.location.href = data.url
                }
            }
        })
        return {
            status
        }
    }

})
</script>

<style scoped>

</style>
